import { render, staticRenderFns } from "./TalentFestHome.vue?vue&type=template&id=1b24cecd&scoped=true"
import script from "./TalentFestHome.vue?vue&type=script&setup=true&lang=js"
export * from "./TalentFestHome.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b24cecd",
  null
  
)

export default component.exports